// Datos del sitio que usan el componente <Seo> y el JSON-LD.
//
// El título y la descripción están DUPLICADOS en public/index.html (los que lee
// WhatsApp/Facebook/Twitter, que no ejecutan JS). Si se cambian acá, hay que
// cambiarlos también allá a mano. Ver docs/SEO.md.
export const site = {
  name: 'CholloMan',
  url: 'https://cholloman.com',
  tagline: 'Ofertas y chollos de las mejores tiendas',
  description:
    'Ofertas y chollos de Amazon, MediaMarkt, El Corte Inglés, AliExpress y más. Los buscamos por vos y te avisamos cuando baja el precio.',
  // Cuadrada y con fondo sólido (naranja), no transparente.
  logo: 'https://cholloman.com/logo512.png',
  telegram: ['https://t.me/ElCholloMan', 'https://t.me/CholloMan_Bot'],
};
